<template>
  <div class="listing_manager_header">
    <div class="listing_title">
      <h1 class="title">
        Google Listing Manager
      </h1>
      <div
        v-if="false"
        class="verified"
      >
        <!-- Hidden for later review -->
        <svg-vue
          class="verified_icon"
          icon="icons/checkmark"
        />
      </div>
    </div>

    <div class="listing_buttons">
      <div class="select_location">
        <custom-select
          v-model="location"
          :options="connectedLocations"
          :validation-errors="errors.scope"
          placeholder="Select a Location"
        >
          <template #option="{ option }">
            <div class="location_option">
              <span>{{ option.label }}</span>
              <small>{{ option.address }}</small>
            </div>
          </template>
        </custom-select>
      </div>

      <primary-button
        v-if="showHelpVideosAndTours"
        class="help_vid"
        size="md"
        @click="helpVideoModalOpen = true"
      >
        <template #icon>
          <i class="fal fa-video" />
        </template>
        Help
      </primary-button>

      <primary-anchor
        v-if="canEditLocation"
        class="manage_btn tooltipster"
        href="/local/gmb/settings"
        size="md"
        title="Manage locations"
      >
        <template #icon>
          <i class="fa fa-cog" />
        </template>
      </primary-anchor>
    </div>
  </div>
  <help-video-modal
    v-if="helpVideoModalOpen"
    @close="helpVideoModalOpen = false"
  />
</template>

<script>
import CustomSelect from "../../../../../views/reports/components/global/forms/CustomSelect";
import PrimaryButton from "../../../global/buttons/PrimaryButton";
import {mapActions, mapGetters, mapMutations} from "vuex";
import PrimaryAnchor from "../../../global/buttons/PrimaryAnchor";
import HelpVideoModal from "../modals/HelpVideoModal";

export default {
  components: {
    HelpVideoModal,
    PrimaryAnchor,
    PrimaryButton,
    CustomSelect,
  },
  data() {
    return {
      errors: {},
      helpVideoModalOpen: false,
    }
  },
  computed: {
    ...mapGetters('user', [
        'canEditLocation',
    ]),
    ...mapGetters('businessProfile', [
      'connectedLocations',
      'selectedLocation',
    ]),
    ...mapGetters('whitelabel', [
      'showHelpVideosAndTours',
    ]),
    location: {
      get() {
        return this.selectedLocation;
      },
      set(value) {
        this.updateSelectedLocation(value);
        this.clearLocation();
        this.clearQuestions();
      }
    }
  },
  methods: {
    ...mapMutations('editListing', [
      'openHelpVideoModal',
    ]),
    ...mapActions('businessProfile', [
      'updateSelectedLocation',
      'clearLocation',
      'clearQuestions',
    ]),
  }
}
</script>

<style lang="scss" scoped>
.listing_manager_header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 1rem;

  .listing_title {
    display: flex;
    width: calc(60% - 1rem);
    align-items: center;

    .title {
      font-weight: 700;
      line-height: 1.25;
      letter-spacing: -0.042em;
      color: #040707;
      font-size: 2.5rem;
      max-width: 90%;
      word-break: break-word;
    }

    .verified {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 1rem;
      background-color: #37B2A8;
      width: 2.5rem;
      height: 2.5rem;
      border-radius: 50%;

      .verified_icon {
        width: 18px;
        height: 18px;
      }
    }

    .help_vid {
      margin-left: auto;
      width: auto;
    }

  }

  .listing_buttons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: calc(40% - 1rem);

    .select_location {
      width: 15rem;

      :deep(.custom_input) {
        margin-bottom: 0;

        .multiselect-single-label {
          width: 200px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: inline-block;
          margin: auto;
          position: relative;
          padding-left: 1rem;
          padding-right: 1rem;
        }
      }
    }

    .manage_btn, .help_vid {
      width: auto;
    }

    > *:not(:last-child) {
      margin-right: .5rem;
    }
  }
}

.location_option {
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
</style>
